import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TabsviewComponent } from './tabsview.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path:'',
				component: TabsviewComponent
			}
		])
	],
	exports: [
		RouterModule
	]
})
export class TabsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/view/tabsview/tabs-routing.module.ts